import React, { Component } from "react";

import { reduxForm } from 'redux-form';
import { connect } from 'react-redux';

//material ui components
import Grid from '@material-ui/core/Grid';

//material components
import Paper from '@material-ui/core/Paper';

//menuItems

class ModalVoiceSetting extends Component {
    constructor(props) {
        super();
        this.state = {
            open: false,
            //Resize
            rootFontSize: {
                name: 'xs',
                fontSize: '58%',
                maxWidht: 970,
            },
        };
    }

    componentWillMount() {
        window.addEventListener("resize", this.resize.bind(this));
        this.resize();
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.resize.bind(this));
    }

    resize() {
        this.setState({ isMobile: window.innerWidth <= 960 });

        const sizes = {
            xs: {
                name: 'xs',
                fontSize: '58%',
                maxWidht: 600,
            },
            sm: {
                name: 'sm',
                fontSize: '60%',
                maxWidht: 1024,
            },
            md: {
                name: 'md',
                fontSize: '80%',
                maxWidht: 1880,
            },
            lg: {
                name: 'lg',
                fontSize: '100%',
                maxWidht: 1920,
            },
        };

        const windowWidht = window.innerWidth;
        const windowHeiht = window.innerHeight;

        let rootFontSize = sizes.xs;

        if (windowWidht > sizes.md.maxWidht) {
            rootFontSize = sizes.lg;
        } else if (windowWidht > sizes.sm.maxWidht) {
            rootFontSize = sizes.md;
        } else if (windowWidht > sizes.xs.maxWidht) {
            rootFontSize = sizes.sm;
        } else {
            rootFontSize = sizes.xs;
        }


        this.setState({
            rootFontSize: rootFontSize,
            windowWidht: windowWidht,
            windowHeiht: windowHeiht,
        });
    }

    //#region  Inner components

    RenderModalContent = () => {

        return (
            <Grid>
                <Paper elevation={3} className="paperModalVoiceSetting" square='false' color='secondary'>
                    <Grid id='menu_item_deletetion_modal' container justify='flex-start' alignItems='baseline' style={{ height: '100%' }} >
                        <Grid item container>
                            <Grid item justify='center' style={{ width: '100%' }} alignItems='center'>
                                <this.RenderTitleContainer />
                            </Grid>
                            <Grid item justify='center' alignItems='center'>
                                <this.RenderMessageContainer />
                            </Grid>
                            <Grid item container className="ModalButtonsContainer alingCenter" style={{ paddingTop: '80px' }} justify='flex-end'>
                                <this.RenderButtonsContainer />
                            </Grid>
                        </Grid>
                    </Grid>
                </Paper>
            </Grid>
        );
    };


    RenderButtonsContainer = () => {
        return (
            this.props.enable === false ?
                <Grid item container className="alingCenter" direction='row'>
                    <Grid item xs={10}>
                        <Grid item container direction='row-reverse'>
                            <Grid item container className="VoiceSettingModalButtonYes skybluebtn-engage alingCenter">
                                <Grid id='close_repair_close_btn' item container className="alingCenter" onClick={() => this.props.OnEnableVoice()}>
                                    Yes, Enable Voice
                                </Grid>
                            </Grid>
                            <Grid item container className="VoiceSettingModalButtonCancel alingCenter">
                                <Grid id='close_repair_return_btn' item container className="alingCenter" onClick={() => this.props.OnCancelHandler()}>
                                    No, Cancel
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
                :
                <Grid item container className="alingCenter" direction='row'>
                    <Grid item xs={10}>
                        <Grid item container direction='row-reverse'>
                            <Grid item container className="VoiceSettingModalButtonYes alingCenter">
                                <Grid id='cancel_repair_cancel_btn' item container className="alingCenter" onClick={() => this.props.OnDisableVoice()}>
                                    Yes, Disable Voice
                                </Grid>
                            </Grid>
                            <Grid item container className="VoiceSettingModalButtonCancel alingCenter">
                                <Grid id='cancel_repair_return_btn' item container className="alingCenter" onClick={() => this.props.OnCancelHandler()}>
                                    No, Cancel
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
        );
    };

    RenderMessageContainer = () => {
        const sMessage = this.props.isCommunity === true ? "entire community" : 'resident`s eHubs'

        return (
            this.props.enable === true ?
                <Grid item container className="alingCenter" direction='row'>
                    <Grid item xs={10} className="VoiceSubTitleModal">
                        <Grid>You are about to disable voice commands and remove FAV1 and FAV2 button customization.</Grid>
                        <Grid>Do you want to disable voice for the {sMessage}?</Grid>
                    </Grid>
                </Grid>
                :
                <Grid item container className="alingCenter" direction='row'>
                    <Grid item xs={10} className="VoiceSubTitleModal">
                        <Grid>You are about to enable voice commands and add FAV1 and FAV2 button customization.</Grid>
                        <Grid>Do you want to enable voice for the {sMessage}?</Grid>
                    </Grid>
                </Grid>
        );
    };

    RenderTitleContainer = () => {
        return (
            <Grid item container xs={12} direction='row-reverse'>
                    <div className="engage-nav VoiceTitleModal" onClick={() => this.props.OnCancelHandler()}>
                        <img
                            src='https://engage360.s3.amazonaws.com/Icons/circle-xmark.svg'
                            alt='close'
                            className="closeIcon"
                            height="35px"
                        />
                    </div>
            </Grid>
        );
    }
    //#endregion

    render() {
        return (
            <main style={{}}>
                <div>
                    <this.RenderModalContent />
                </div>
            </main>
        )
    }
}

function mapStateToProps(state, dispatch) {

    return {
    }
}


ModalVoiceSetting = reduxForm({
    form: 'ModalVoiceSettingForm',
    enableReinitialize: true,
})(ModalVoiceSetting);

export default connect(mapStateToProps, {})(ModalVoiceSetting);

